import { jsx as e, jsxs as x } from "react/jsx-runtime";
import { aV as g, w as L } from "../../vendor-Dd6qj6gJ.js";
import { useRef as P } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as w } from "../../utils/omitStyleRenderProps/index.js";
import { FieldDescription as y } from "../FieldDescription/index.js";
import { FieldError as C } from "../FieldError/index.js";
import { SelectFieldLabel as N } from "./SelectFieldLabel/index.js";
import { Surface as R } from "../Surface/index.js";
import { SelectFieldValueProvider as V } from "./SelectFieldContext/index.js";
import { SelectValue as j } from "./SelectValue/index.js";
import { SelectMenuContent as A } from "./SelectFieldContent/index.js";
import { SelectListBox as M } from "./SelectListBox/index.js";
import '../../assets/index52.css';const z = "_selectField_dho2r_1", B = "_popover_dho2r_41", D = "_surface_dho2r_48", l = {
  selectField: z,
  popover: B,
  surface: D
};
function X({
  label: r,
  errorMessage: d,
  description: n,
  items: t,
  onLoadMore: f,
  placeholder: m,
  search: a,
  "aria-label": c,
  isLoading: h = !1,
  hasMore: p = !0,
  isVirtualized: u = !1,
  fullWidth: v = !1,
  startIcon: S,
  horizontal: F = !1,
  ...o
}) {
  const i = P(null), s = (r ?? c ?? "options").toString().toLocaleLowerCase(), _ = m ?? `Choose ${s}`, b = a?.placeholder ?? `Search ${s}`, $ = Array.isArray(o.value) ? o.value.length > 0 : !!o.value;
  return /* @__PURE__ */ e(
    g,
    {
      ...w(o),
      "aria-label": r ? void 0 : c,
      "data-component": "SelectField",
      "data-selection-mode": o.selectionMode,
      "data-has-selection": $ || void 0,
      "data-fullwidth": v || void 0,
      "data-horizontal": F || void 0,
      className: l.selectField,
      children: /* @__PURE__ */ x(V, { items: t, children: [
        /* @__PURE__ */ e(N, { children: r }),
        /* @__PURE__ */ e(j, { ref: i, placeholder: _, startIcon: S }),
        /* @__PURE__ */ e(y, { children: n }),
        /* @__PURE__ */ e(C, { children: d }),
        /* @__PURE__ */ e(L, { className: l.popover, triggerRef: i, children: /* @__PURE__ */ e(R, { className: l.surface, children: /* @__PURE__ */ e(A, { search: a, searchPlaceholder: b, children: /* @__PURE__ */ e(
          M,
          {
            items: t,
            isLoading: h,
            onLoadMore: f,
            hasMore: p,
            isVirtualized: u
          }
        ) }) }) })
      ] })
    }
  );
}
export {
  X as SelectField
};
